import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from './Button';
import './CustomerNav.css';

const navLinkClass = ({ isActive }) =>
  'customer-nav__link' + (isActive ? ' customer-nav__link--active' : '');

const CustomerNav = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Close menu whenever the route changes
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMenuOpen(false);
  }, [location.pathname]);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="customer-nav" ref={navRef}>
      <div className="customer-nav__inner">
        {/* Desktop nav links */}
        <div className="customer-nav__links">
          <NavLink to="/dashboard" className={navLinkClass}>Dashboard</NavLink>
          <NavLink to="/products" className={navLinkClass}>Products</NavLink>
          <NavLink to="/orders" className={navLinkClass}>Orders</NavLink>
          <NavLink to="/invoices" className={navLinkClass}>Invoices</NavLink>
          <NavLink to="/profile" className={navLinkClass}>Profile</NavLink>
        </div>

        {/* Desktop user / logout */}
        <div className="customer-nav__user">
          {user && <span className="customer-nav__username">{user.email}</span>}
          <Button variant="secondary" size="small" onClick={handleLogout}>
            Log out
          </Button>
        </div>

        {/* Mobile hamburger button */}
        <button
          className={`customer-nav__hamburger${menuOpen ? ' customer-nav__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="customer-nav__mobile-menu">
          <NavLink to="/dashboard" className={navLinkClass}>Dashboard</NavLink>
          <NavLink to="/products" className={navLinkClass}>Products</NavLink>
          <NavLink to="/orders" className={navLinkClass}>Orders</NavLink>
          <NavLink to="/invoices" className={navLinkClass}>Invoices</NavLink>
          <NavLink to="/profile" className={navLinkClass}>Profile</NavLink>
          <div className="customer-nav__mobile-divider" />
          {user && (
            <div className="customer-nav__mobile-email">{user.email}</div>
          )}
          <button className="customer-nav__mobile-logout" onClick={handleLogout}>
            Log out
          </button>
        </div>
      )}
    </nav>
  );
};

export default CustomerNav;
